var render, staticRenderFns
import script from "./GetRelativeRouteNameMixin.vue?vue&type=script&lang=ts"
export * from "./GetRelativeRouteNameMixin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d32b3f6')) {
      api.createRecord('8d32b3f6', component.options)
    } else {
      api.reload('8d32b3f6', component.options)
    }
    
  }
}
component.options.__file = "src/mixins/route/GetRelativeRouteNameMixin.vue"
export default component.exports